//Please add the language resource
const confirm = {
  orderNo:'OrderNo',
  planDeliveryDate:'PlanDeliveryDate',
  shiptoName:'ShiptoName',
  soldName:'SoldName',
  totalVolume:'TotalVolume',
  shiptoTel:'ShiptoTel',
  totalNetWegit:'TotalNetWegit',
  orderStatus:'OrderStatus',
  approveStatus:'ApproveStatus',
  shiptoNo:'ShiptoNo',
  feedbackStatus:'FeedbackStatus',
  inputDate:'InputDate',
  orderRemark:'OrderRemark',
  customerNo:'CustomerNo',
  signRemark:'SignRemark',
  totalPrice:'TotalPrice',
  totalQty:'TotalQty',
  signDate:'SignDate',
  signUserNo:'SignUserNo',
  pickUpFlag:'PickUpFlag',
  updateDate:'UpdateDate',
  orderDate:'OrderDate',
  updateUserNo:'UpdateUserNo',
  shiptoAddr:'ShiptoAddr',
  sapNo:'SapNo',
  carrierName:'CarrierName',
  customerName:'CustomerName',
  soldNo:'SoldNo',
  totalNoTaxPrice:'TotalNoTaxPrice',
  inputUserNo:'InputUserNo',
  totalGrossWegit:'TotalGrossWegit',
  materielName:'商品名称',
  orderQty:'订单数量',
  actShipQty:'发货数量',
  signQty:'签收数量',
  signAbnormalReason:'签收异常原因',
  endUserName:'终端客户',
  saleName:'销售',
  dangerousFlag:'危险品',
  netWeight:'单箱重量',
  volume:'单箱体积',
  taxPrice:'含税箱价',


  currentApprover:'当前处理人',
  currentApproveLevel:'当前处理步骤',
  zsmpReqNo:'申请单号',
  reqUserNo:'申请人',
  reqDate:'申请时间',
  reqType:'申请类型',
  regionName:'区域',
  channelName:'渠道',
  shipDcNo:'发货DC',
  shipNo:'ShipTo编号',
  shipName:'ShipTo',
  uploadCustomerName:'客户组',
  transOrderFlag:'转单次数',
  totalBoxQty:'内领单总箱数',
  totalPackageQty:'内领单总包数',
  actBoxQty:'抓单箱数',
  useBoxQty:'剩余可用箱数',
  ioNo:'IO号',
  ioStatus:'IO号状态',

  productNo: 'SKU号码',
  materielNo: '物料编号',
  zhName: '物料描述',
  typeName: '物料类型',
  categoryName: 'Category',
  tier: 'Tier',
  containerSize: '箱容',
  boxQty: '箱数',
  packageQty: '包数',
  msg:{
  },
  fullGoodsFlag:'fullGoods'
};
export default confirm



// WEBPACK FOOTER //
// ./src/page/order/batch/lang/batch.en.js